import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import { useAdyen, useLogger, useI18n } from '~Hooks';
import { useStorage } from '~Components/Storage';
import useModal from '~ComponentsImproved/Modal/useModal';
import Modal from '~ComponentsImproved/Modal';
import { RefundProps } from '../types';
import { AdeynTerminal } from '../types';

const Button = styled.button<{
  disabled?: boolean;
}>`
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  width: 100%;
  font-size: 18px;
  border: 1px solid #fff;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  align-items: center;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0px 2px 13px -5px rgba(0, 0, 0, 0.12), 0px 1px 2px 1px rgba(0, 0, 0, 0.2);
  flex-grow: 1;
  height: 48px;
  border: 1px solid rgb(255, 255, 255, 0.3);
  color: #fff;
  font-weight: bold;
  background: #f5416e;
  margin: 8px 0;
`;

const Content = styled.div`
  width: 100%;
  max-width: 560px;
  padding: 24px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.h3`
  margin-top: 0;
  font-size: 16px;
  color: #000;
`;

/*
 * 1. Should show modal
 * 2. Choose terminal
 * 3. Call refundPayment
 * 4. Call OnCompleted
 */
export const RefundAdyen = (props: RefundProps) => {
  const { amount, transactionId, onFail, onCompleted, transactionCreatedAt } = props;
  const { i18n } = useI18n();

  const { refundPayment } = useAdyen();
  const [storage] = useStorage();
  const { isShowing, toggle } = useModal();
  const logger = useLogger('refund-adyen');

  const openModal = () => {
    if (!isShowing) toggle();
  };

  const closeModal = () => {
    if (isShowing) toggle();
  };

  const handleHideModal = () => {
    closeModal();
    onFail();
  };

  const [adyenTerminal, setAdyenTerminal] = useState<AdeynTerminal | null>();

  const handleSelectTerminal = (terminal: AdeynTerminal) => {
    setAdyenTerminal({ IP: terminal.IP, POIID: terminal.POIID });
    closeModal();
  };

  /* On first render open modal */
  useEffect(() => openModal(), []);

  useEffect(() => {
    const terminalId = adyenTerminal?.POIID;

    /* On valid args initiate refund */
    if (transactionId && terminalId) {
      logger.info('Refund - Adyen Refund initiated on transactionId: ' + transactionId);

      refundPayment({
        transactionId,
        createdAt: transactionCreatedAt,
        amount,
        terminalId,
      }).then(({ success, message }) => {
        if (success) {
          logger.info('Refund - Adyen Refund successful on transactionId: ' + transactionId);
          onCompleted();
        } else {
          logger.error('Refund - Adyen Refund failed on transactionId: ' + transactionId, {
            err: message,
          });
          onFail(message);
        }
      });
    }
  }, [adyenTerminal]);

  return (
    <Modal isShowing={isShowing} hide={handleHideModal}>
      <Content>
        <Header>{i18n('Refunds.ChooseTerminal')}</Header>
        {storage.adyenTerminals.map((terminal) => (
          <Button key={terminal.POIID} onClick={() => handleSelectTerminal(terminal)}>
            {terminal.POIID}
          </Button>
        ))}
      </Content>
    </Modal>
  );
};
